import React from 'react';

import { MenuItem, MenuItemProps } from './MenuItem';

export type MenuListProps = {
  items: MenuItemProps[];
  onLinkClick?: (
    params: { title: string } | { url: string; keepMenuOpen?: boolean }
  ) => void;
  suffixItem?: MenuItemProps;
};

export function MenuList({ items, suffixItem, onLinkClick }: MenuListProps) {
  const menuItems = items.map((item, index) => (
    <li
      className='group-[[data-type="extra"]]/menu-group:headerLg:max-w-full headerLg:w-auto  headerLg:min-w-fit w-full origin-left'
      key={`${item.title}-${item.url}-${index}`}
    >
      <MenuItem {...item} onLinkClick={onLinkClick} />
    </li>
  ));

  return (
    <ul className='headerLg:flex-nowrap flex size-full h-full  flex-col flex-wrap gap-x-10 gap-y-2 group-[[data-type="extra"]]/menu-group:gap-3'>
      {menuItems}
      {suffixItem && (
        <li
          className='group-[[data-type="extra"]]/menu-group:headerLg:max-w-full group/menu-list-item w-auto origin-left'
          key={`${suffixItem.title}-${suffixItem.url}-suffix`}
          data-type='suffix'
        >
          <MenuItem {...suffixItem} />
        </li>
      )}
    </ul>
  );
}
